import {
    Checkbox,
    styled,
    TextField,
    Typography,
    FormControlLabel,
    Select,
    MenuItem,
} from '@mui/material';
import { List, ListItem } from '../../../components/List';
import { Info } from '../../../components/Info';
import { formationWithOptionsMapping } from '../../constants';
import { formationsWithOptionsSummaryType, formationWithOptionSlugType } from '../../types';

function FormationWithOptions(props: {
    slug: formationWithOptionSlugType;
    shouldHideIntra?: boolean;
    formationsWithOptionsSummary: formationsWithOptionsSummaryType;
    setFormationsWithOptionsSummary: (
        formationsWithOptionsSummary: formationsWithOptionsSummaryType,
    ) => void;
}) {
    const formationInfo = formationWithOptionsMapping[props.slug];
    const selectedOption = props.formationsWithOptionsSummary[props.slug].option;
    const selectedDate = props.formationsWithOptionsSummary[props.slug].date;
    if (formationInfo.dates.length === 0) {
        return (
            <Container>
                <Title variant="h4">{formationInfo.title}</Title>
                <Typography>
                    Aucune date n'est actuellement disponible pour cette formation.
                </Typography>
            </Container>
        );
    }

    return (
        <Container>
            <Title variant="h4">{formationInfo.title}</Title>
            <List>
                <ListItem>
                    <StyledFormControlLabel
                        control={<Checkbox checked={selectedOption === 'inter'} />}
                        onChange={(_, checked) => {
                            if (checked) {
                                setSelectedOption(
                                    'inter',
                                    formationInfo.dates.length === 1
                                        ? formationInfo.dates[0].value
                                        : undefined,
                                );
                            } else {
                                setSelectedOption(undefined);
                            }
                        }}
                        label={
                            <CheckboxLabel>
                                Inter
                                <Info title="Formation au sein de l'ésaj, à Paris (13 rue de Santeuil 75005)" />
                            </CheckboxLabel>
                        }
                        name={`${props.slug}-training-option-inter`}
                    />

                    <DateLabel>Date{formationInfo.dates.length > 1 && ' souhaitée'} :</DateLabel>
                    {formationInfo.dates.length > 1 ? (
                        <Select
                            variant="standard"
                            required={selectedOption === 'inter'}
                            disabled={selectedOption !== 'inter'}
                            value={selectedDate}
                            onChange={(e) => setSelectedDate(e.target.value)}
                        >
                            {formationInfo.dates.map((date) => (
                                <MenuItem disabled={date.isPast} value={date.value}>
                                    {date.label}
                                </MenuItem>
                            ))}
                        </Select>
                    ) : (
                        <Typography>{formationInfo.dates[0].label}</Typography>
                    )}
                </ListItem>
                {!props.shouldHideIntra && (
                    <ListItem>
                        <StyledFormControlLabel
                            control={<Checkbox checked={selectedOption === 'intra'} />}
                            onChange={(_, checked) =>
                                setSelectedOption(checked ? 'intra' : undefined)
                            }
                            label={
                                <CheckboxLabel>
                                    Intra
                                    <Info title="Formation sur mesure au sein de votre entreprise ou collectivité (sur demande)" />
                                </CheckboxLabel>
                            }
                            name={`${props.slug}-training-option-intra`}
                        />

                        <DateLabel>Date souhaitée :</DateLabel>
                        <TextField
                            required={selectedOption === 'intra'}
                            disabled={selectedOption !== 'intra'}
                            type="date"
                            value={selectedOption === 'intra' && !!selectedDate ? selectedDate : ''}
                            onChange={(e) => setSelectedDate(e.target.value)}
                            placeholder="JJ/MM/AAAA"
                            variant="standard"
                        />
                    </ListItem>
                )}
            </List>
        </Container>
    );

    function setSelectedOption(option: 'inter' | 'intra' | undefined, date?: string | undefined) {
        props.setFormationsWithOptionsSummary({
            ...props.formationsWithOptionsSummary,
            [props.slug]: {
                ...props.formationsWithOptionsSummary[props.slug],
                option,
                date: date ?? '',
            },
        });
    }

    function setSelectedDate(date: string) {
        props.setFormationsWithOptionsSummary({
            ...props.formationsWithOptionsSummary,
            [props.slug]: {
                ...props.formationsWithOptionsSummary[props.slug],
                date,
            },
        });
    }
}

const Container = styled('div')(({ theme }) => ({}));
const Title = styled(Typography)(({ theme }) => ({}));
const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
    marginRight: theme.spacing(10),
}));
const CheckboxLabel = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
}));
const DateLabel = styled(Typography)(({ theme }) => ({ marginRight: theme.spacing(2) }));

export { FormationWithOptions };
